import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
  MenuItem,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../../Navbar/Navbar";
import baseURL from "../../config";
import BgImage from "../../assets/shipimage.jpg"; // Background image
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";


const Signup = () => {
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loginuser, setLoginuser] = useState({
    userType: location.state?.userType || "",
    username: "",
    email: "",
    password: "",
    confirmpassword: "",
    companyName: "",
    address: "",
    phoneNumber: "",
    country: "",
  });

  const [error, setError] = useState("");
  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setLoginuser({ ...loginuser, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const {
      password,
      confirmpassword,
      userType,
      companyName,
      address,
      phoneNumber,
      country,
      email,
      username,
    } = loginuser;

    if (password !== confirmpassword) {
      setError("Passwords do not match");
      return;
    }

    if (!userType) {
      setError("Please select a user type");
      return;
    }

    if (
      userType === "vessel_owner" &&
      (!companyName || !address || !phoneNumber || !country)
    ) {
      setError("Please fill in all Vessel Owner details.");
      return;
    }

    try {
      // Check if email already exists
      const checkEmailResponse = await axios.post(
        `${baseURL}/api/check-email`,
        { email }
      );

      if (checkEmailResponse.data.exists) {
        if (userType === "crew") {
          // Only for "crew" users
          toast.info("Email already exists. ");
          // setTimeout(() => navigate("/crewprofile"), 1000);
        } else {
          toast.error("Email already exists!"); // Show error for other user types
        }
        return; // Stop execution if email exists
      }

      // Prepare request data
      const requestData = {
        userType,
        username,
        email,
        password,
      };

      // Include vessel owner details if applicable
      if (userType === "vessel_owner") {
        requestData.companyName = companyName;
        requestData.address = address;
        requestData.phoneNumber = phoneNumber;
        requestData.country = country;
      }

      // Make signup request
      const response = await axios.post(`${baseURL}/api/signup`, requestData);

      localStorage.setItem("userEmail", email);
      toast.success("Signup successful! Redirecting...");
      setTimeout(() => navigate("/otp"), 1000);
    } catch (err) {
      setError("An error occurred during signup");
      toast.error("Signup failed! Try again.");
      console.error("Signup error:", err.response?.data || err);
    }
  };

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);
 const toggleConfirmPasswordVisibility = () => setShowConfirmPassword((prev) => !prev);


  return (
    <>
      {/* Navbar stays at the top */}
      <Navbar />

      <Box
        sx={{
          width: "100%", // Ensure the background covers full width
          height: "100vh", // Ensure the background covers full height
          backgroundImage: `url(${BgImage})`, // Background image
          backgroundSize: "cover", // Make the background cover the entire screen
          backgroundPosition: "center", // Center the background image
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          position: "relative",
          zIndex: 1,
          paddingTop: "80px", // Add padding to make space for the fixed Navbar
          overflowY: "auto", // Enable scrolling if the form extends beyond the screen
        }}
      >
        {/* Center the signup form */}
        <Container maxWidth="sm" sx={{ zIndex: 2 }}>
          <Paper
            elevation={10}
            sx={{
              p: 4,
              borderRadius: 3,
              backdropFilter: "blur(8px)",
              bgcolor: "rgba(255, 255, 255, 0.8)",
              maxHeight: "calc(100vh - 160px)", // Adjust the max height to avoid overlapping with Navbar and background
              overflowY: "auto", // Make the form scrollable if it's too long
            }}
          >
            <Typography variant="h4" fontWeight="bold" mb={2}>
              Create an Account
            </Typography>
            <form onSubmit={handleSubmit}>
              <TextField
                select
                fullWidth
                label="User Type"
                name="userType"
                value={loginuser.userType}
                onChange={inputHandler}
                required
                margin="normal"
                sx={{
                  borderRadius: 2,
                  fontSize: "0.875rem",
                  height: "40px",
                }}
              >
                <MenuItem value="">Select User Type</MenuItem>
                <MenuItem value="crew">Crew</MenuItem>
                <MenuItem value="crewing_agent">Crewing Agent</MenuItem>
                <MenuItem value="vessel_owner">Vessel Owner</MenuItem>
                <MenuItem value="travel_agent">Travel Agent</MenuItem>
                <MenuItem value="institute">Marine Institute</MenuItem>
              </TextField>
              <TextField
                fullWidth
                label="Username"
                name="username"
                value={loginuser.username}
                onChange={inputHandler}
                required
                margin="normal"
                sx={{
                  borderRadius: 2,
                  fontSize: "0.875rem",
                  height: "40px",
                }}
              />
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={loginuser.email}
                onChange={inputHandler}
                required
                margin="normal"
                sx={{
                  borderRadius: 2,
                  fontSize: "0.875rem",
                  height: "40px",
                }}
              />
              <TextField
                fullWidth
                label="Password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={loginuser.password}
                onChange={inputHandler}
                required
                margin="normal"
                sx={{
                  borderRadius: 2,
                  fontSize: "0.875rem",
                  height: "40px",
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                label="Confirm Password"
                name="confirmpassword"
                type={showConfirmPassword ? "text" : "password"}
                value={loginuser.confirmpassword}
                onChange={inputHandler}
                required
                margin="normal"
                sx={{
                  borderRadius: 2,
                  fontSize: "0.875rem",
                  height: "40px",
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={toggleConfirmPasswordVisibility} edge="end">
                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {loginuser.userType === "vessel_owner" && (
                <>
                  <TextField
                    fullWidth
                    label="Company Name"
                    name="companyName"
                    value={loginuser.companyName}
                    onChange={inputHandler}
                    required
                    margin="normal"
                    sx={{
                      fontSize: "0.875rem",
                      height: "40px",
                    }}
                  />
                  <TextField
                    fullWidth
                    label="Address"
                    name="address"
                    value={loginuser.address}
                    onChange={inputHandler}
                    required
                    margin="normal"
                    sx={{
                      fontSize: "0.875rem",
                      height: "40px",
                    }}
                  />
                  <TextField
                    fullWidth
                    label="Phone Number"
                    name="phoneNumber"
                    type="tel"
                    value={loginuser.phoneNumber}
                    onChange={inputHandler}
                    required
                    margin="normal"
                    sx={{
                      fontSize: "0.875rem",
                      height: "40px",
                    }}
                  />
                  <TextField
                    fullWidth
                    label="Country"
                    name="country"
                    value={loginuser.country}
                    onChange={inputHandler}
                    required
                    margin="normal"
                    sx={{
                      fontSize: "0.875rem",
                      height: "40px",
                    }}
                  />
                </>
              )}

              {error && (
                <Typography color="error" mt={1}>
                  {error}
                </Typography>
              )}

              <Button
                variant="contained"
                color="secondary"
                fullWidth
                sx={{
                  mt: 3,
                  p: 1.5,
                  fontSize: "0.875rem",
                  fontWeight: "bold",
                  borderRadius: 2,
                  height: "40px",
                }}
                type="submit"
              >
                Sign Up
              </Button>
            </form>

            <Typography variant="body2" mt={2}>
            Already have an account? <Link to="/login">Login</Link>
            </Typography>
          </Paper>
        </Container>
      </Box>

      <ToastContainer position="top-right" autoClose={5000} />
    </>
  );
};

export default Signup;
